/*
 * Public API Surface of ngx-element
 */

export * from './lib/ngx-element.module';
